export default __webpack_public_path__ + "static/media/php.23397daa.png";